import { css } from 'lit';
import { color, rem, spacing } from '@thiememeulenhoff/lit-sdk';

export const styles = css`
  /* stylelint-disable value-no-vendor-prefix */

  *,
  :after,
  :before {
    box-sizing: border-box;
  }

  .footer[hidden] {
    display: none;
  }

  .truncate {
    -webkit-box-orient: vertical;
    display: -webkit-box;
    inline-size: 100%;
    max-block-size: var(--truncate-height, auto);
    overflow: hidden;
    transition: max-block-size var(--tm-transition-duration-normal)
      var(--tm-transition-function-ease-out);
  }

  .truncate.truncate-not-applicable {
    max-block-size: unset;
    overflow: unset;
  }

  .truncate__inner {
    position: relative;
  }

  .truncate__inner::after {
    background: linear-gradient(
      to bottom,
      transparent 0%,
      var(--fade-color, white) 100%
    );
    block-size: 4em;
    content: '';
    inset-block-end: 0;
    inset-inline: 0;
    inset-inline-end: 0;
    pointer-events: none;
    position: absolute;
    transition: block-size var(--tm-transition-duration-normal)
      var(--tm-transition-function-ease-out);
  }

  .truncate--footer-hovered .truncate__inner::after {
    block-size: 2em;
  }

  .truncate--line-clamped:not(.truncate-not-applicable) {
    -webkit-line-clamp: var(--lines, none);
  }

  .truncate--line-clamped:not(.truncate-not-applicable) .truncate__inner {
    max-block-size: var(--truncate-height, auto);
  }

  .truncate--expanded {
    max-block-size: var(--truncate-height-expanded, auto);
  }

  .truncate-not-applicable .truncate__inner::after,
  .truncate--expanded .truncate__inner::after {
    opacity: 0;
  }

  footer {
    font-size: ${rem(14)};
    text-align: start;
    &.disabled {
      display: none;
    }
  }

  a {
    align-items: center;
    color: ${color('grey', 600)};
    cursor: pointer;
    display: inline-flex;
    gap: ${spacing(100)};
  }

  a:hover {
    color: ${color('grey', 800)};
  }

  a:focus-visible {
    outline-color: var(--tm-focus-ring-color);
    outline-offset: var(--tm-focus-ring-offset);
    outline-style: var(--tm-focus-ring-style);
    outline-width: var(--tm-focus-ring-width);
  }
`;
